// extracted by mini-css-extract-plugin
export default {"filtrRez":"FiltrtagCloud_filtrRez__xtpzu","itemFiltrRez":"FiltrtagCloud_itemFiltrRez__-Kn0V"};